// JS
import '../../custom/js/custom/index';
import '../../custom/js/custom/components/collage-carousel';
import '../../custom/js/custom/components/hero-video';
import '../../custom/js/custom/components/modal';
import '../../custom/js/custom/components/testimonial';
import '../../custom/js/custom/components/homeTeaserVideo';

// Base SCSS
import '../../custom/scss/common/base.scss';
import '../../custom/scss/custom/layout.scss';

// Components SCSS
import '../../custom/scss/custom/components/read-more/read-more.scss';
import '../../custom/scss/custom/components/arrow-animated/arrow-animated.scss';
import '../../custom/scss/custom/components/hero/hero.scss';
import '../../custom/scss/custom/components/hero/hero-tall.scss';
import '../../custom/scss/custom/components/hero/hero-homepage.scss';
import '../../custom/scss/custom/components/carousel/carousel.scss';
import '../../custom/scss/custom/components/carousel/collage-carousel.scss';
import '../../custom/scss/custom/components/news/news-item-featured.scss';
import '../../custom/scss/custom/layout/section/section-news.scss';
import '../../custom/scss/custom/components/callout/callout-card.scss';
import '../../custom/scss/custom/components/callout/callout-card-grid.scss';
import '../../custom/scss/custom/components/card/hiw-card.scss';
import '../../custom/scss/custom/components/callout/callout-link.scss';
import '../../custom/scss/custom/components/callout/callout-link-wrap.scss';
import '../../custom/scss/custom/components/app-advertisement/app-advertisement.scss';
import '../../custom/scss/custom/components/school-inspiration/school-inspiration.scss';
import '../../custom/scss/custom/components/content/content-featured.scss';
import '../../custom/scss/custom/components/modal/modal.scss';
import '../../custom/scss/custom/components/modal/event-popup.scss';
import '../../custom/scss/custom/components/card/card.scss';
import '../../custom/scss/custom/components/home/latest-news.scss';
import '../../custom/scss/custom/components/home/video-teaser.scss';
import '../../custom/scss/custom/components/home/home-menu-meet-guidelines.scss';
import '../../custom/scss/custom/components/home/recipes.scss';
import '../../custom/scss/custom/components/home/training.scss';
import '../../custom/scss/custom/components/testimonial/testimonial.scss';
import '../../custom/scss/custom/base/_button.scss';